import { laserficheIntegrationRepo } from "@/repositories/laserficheIntegrationRepo";
import { useObservable } from "@repo/ui/components/Base/hooks/useObservable";

export const useLaserficheListConnections = (tenantId: string) => {
  return useObservable(
    () => laserficheIntegrationRepo.listConnections(tenantId),
    [tenantId]
  );
};

export const useLaserficheGetIntegration = (
  tenantId: string,
  teamId: string | null
) => {
  return useObservable(
    () => laserficheIntegrationRepo.getIntegration(tenantId, teamId),
    [tenantId, teamId]
  );
};

export const useLaserficheGetMetadata = (
  tenantId: string,
  teamId: string | null
) => {
  return useObservable(
    () => laserficheIntegrationRepo.getMetadata(tenantId, teamId),
    [tenantId, teamId]
  );
};

export const useLaserficheGetDirectory = (
  tenantId: string,
  teamId: string | null,
  directoryId: number
) => {
  return useObservable(
    () => laserficheIntegrationRepo.getDirectory(tenantId, teamId, directoryId),
    [tenantId, teamId, directoryId]
  );
};
